const MainDefaultValue: { width: string; height: string } = {
  width: "3.5rem",
  height: "3.5rem",
};

export function MovieIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={MainDefaultValue.width}
      height={MainDefaultValue.height}
      viewBox="0 0 24 24"
    >
      <path
        fill="#fff"
        d="m18 4l2 3h-3l-2-3h-2l2 3h-3l-2-3H8l2 3H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4zm-6.75 11.25L10 18l-1.25-2.75L6 14l2.75-1.25L10 10l1.25 2.75L14 14l-2.75 1.25zm5.69-3.31L16 14l-.94-2.06L13 11l2.06-.94L16 8l.94 2.06L19 11l-2.06.94z"
      />
    </svg>
  );
}

export function MusicIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={MainDefaultValue.width}
      height={MainDefaultValue.height}
      viewBox="0 0 24 24"
    >
      <path
        fill="#fff"
        d="M10 21q-1.65 0-2.825-1.175Q6 18.65 6 17q0-1.65 1.175-2.825Q8.35 13 10 13q.575 0 1.062.137q.488.138.938.413V3h6v4h-4v10q0 1.65-1.175 2.825Q11.65 21 10 21Z"
      />
    </svg>
  );
}

export function FoodIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={MainDefaultValue.width}
      height={MainDefaultValue.height}
      viewBox="0 0 24 24"
    >
      <path
        fill="#fff"
        d="M3 3a1 1 0 0 0-1 1v5.5c0 1.69 1.03 3.13 2.5 3.72v6.28A1.5 1.5 0 0 0 6 21a1.5 1.5 0 0 0 1.5-1.5v-6.28c1.47-.59 2.5-2.03 2.5-3.72V4a1 1 0 0 0-1-1a1 1 0 0 0-1 1v4a.5.5 0 0 1-.5.5A.5.5 0 0 1 7 8V4a1 1 0 0 0-1-1a1 1 0 0 0-1 1v4a.5.5 0 0 1-.5.5A.5.5 0 0 1 4 8V4a1 1 0 0 0-1-1m16.88 0c-.13 0-.26.09-.38.16L16 5.25V9h-4v2h1l1 10h6l1-10h1V9h-4V6.34l2.5-1.5c.5-.28.63-.84.34-1.34c-.21-.36-.58-.55-.96-.5Z"
      />
    </svg>
  );
}

export function FlowerIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={MainDefaultValue.width}
      height={MainDefaultValue.height}
      viewBox="0 0 256 256"
    >
      <path
        fill="#fff"
        d="M210.35 129.36c-.81-.47-1.7-.92-2.62-1.36c.92-.44 1.81-.89 2.62-1.36a40 40 0 1 0-40-69.28c-.81.47-1.65 1-2.48 1.59c.08-1 .13-2 .13-3a40 40 0 0 0-80 0c0 .94 0 1.94.13 3c-.83-.57-1.67-1.12-2.48-1.59a40 40 0 1 0-40 69.28c.81.47 1.7.92 2.62 1.36c-.92.44-1.81.89-2.62 1.36a40 40 0 1 0 40 69.28c.81-.47 1.65-1 2.48-1.59c-.08 1-.13 2-.13 2.95a40 40 0 0 0 80 0c0-.94-.05-1.94-.13-2.95c.83.57 1.67 1.12 2.48 1.59a39.79 39.79 0 0 0 19.94 5.36a40.43 40.43 0 0 0 10.42-1.38a40 40 0 0 0 9.64-73.28ZM128 156a28 28 0 1 1 28-28a28 28 0 0 1-28 28Z"
      />
    </svg>
  );
}

export function RobotIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={MainDefaultValue.width}
      height={MainDefaultValue.height}
      viewBox="0 0 24 24"
    >
      <path
        fill="#fff"
        d="M22 14h-1c0-3.87-3.13-7-7-7h-1V5.73A2 2 0 1 0 10 4c0 .74.4 1.39 1 1.73V7h-1c-3.87 0-7 3.13-7 7H2c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h1v1a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1M9.7 15.45l-.73.73l-1.47 1.47l-2.2-2.2c-.4-.4-.4-1.06 0-1.45c.41-.42 1.06-.42 1.47 0l.73.72l.73-.72c.41-.42 1.06-.42 1.47 0c.4.39.4 1.05 0 1.45m9 0l-.73.73l-1.47 1.47l-2.2-2.2c-.4-.4-.4-1.06 0-1.45c.41-.42 1.06-.42 1.47 0l.73.72l.73-.72c.41-.42 1.06-.42 1.47 0c.4.39.4 1.05 0 1.45Z"
      />
    </svg>
  );
}

export function ShareIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={MainDefaultValue.width}
      height={MainDefaultValue.height}
      viewBox="0 0 48 48"
    >
      <g fill="none" stroke="#ff3366" strokeWidth="4">
        <path
          strokeLinejoin="round"
          d="M8 6h32a2 2 0 0 1 2 2v28L32 22.005c-2.667 1.585-5.333 2.378-8 2.378s-5.333-.793-8-2.378L6 36V8a2 2 0 0 1 2-2Z"
          clipRule="evenodd"
        />
        <path strokeLinecap="round" d="M6 42h36" />
      </g>
    </svg>
  );
}

export function MatchIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={MainDefaultValue.width}
      height={MainDefaultValue.height}
      viewBox="0 0 24 24"
    >
      <path
        fill="#ff3366"
        d="M18 8.31c-.36-.41-.73-.82-1.12-1.21l-.29-.27l.14-.12a3.15 3.15 0 0 0 .9-3.49A3.91 3.91 0 0 0 14 1v2a2 2 0 0 1 1.76 1c.17.4 0 .84-.47 1.31c-.07.08-.15.13-.22.2c-3-2.41-6.29-3.77-7.9-2.16a2.16 2.16 0 0 0-.41.59v.1l-.18.53l-4.41 13.1A3.28 3.28 0 0 0 5.28 22a3.21 3.21 0 0 0 1-.17L20 17.28a1 1 0 0 0 .43-.31l.21-.18c1.43-1.44.51-4.21-1.41-6.9A6.63 6.63 0 0 1 23 9V7a8.44 8.44 0 0 0-5 1.31zM5.7 19.93a1.29 1.29 0 0 1-1.63-1.63l1.36-4.1a10.7 10.7 0 0 0 4.29 4.39zm7-2.33a8.87 8.87 0 0 1-6.3-6.29l1-3l.06.09c.11.22.25.45.39.68s.16.29.26.44s.33.48.51.73s.19.28.3.42s.43.55.66.82l.29.35c.34.39.7.77 1.08 1.16s.68.64 1 1l.33.28l.78.63l.37.28c.28.2.55.4.83.58l.31.2c.36.22.72.43 1.07.61h.05zm6.51-2.23h-.06c-.69.38-3.56-.57-6.79-3.81c-.34-.34-.66-.67-.95-1l-.29-.35l-.53-.64l-.29-.4c-.13-.19-.27-.37-.39-.55l-.26-.42l-.29-.47c-.08-.14-.14-.27-.21-.4s-.15-.26-.21-.4a3.31 3.31 0 0 1-.14-.36c-.05-.13-.11-.26-.15-.38S8.6 6 8.57 5.88s-.05-.22-.07-.32a2.26 2.26 0 0 1 0-.26a1 1 0 0 1 0-.24l.11-.31c.36-.36 2.23 0 4.73 1.9A4.13 4.13 0 0 1 12 7v2a6.45 6.45 0 0 0 3-.94l.48.46c.42.42.81.85 1.18 1.28a5.32 5.32 0 0 0-.6 3.4l2-.39a3.57 3.57 0 0 1 0-1.12a11.3 11.3 0 0 1 .81 1.45c.56 1.32.52 2.06.34 2.23z"
      />
    </svg>
  );
}

export function RecomIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={MainDefaultValue.width}
      height={MainDefaultValue.height}
      viewBox="0 0 24 24"
    >
      <path
        fill="#ff3366"
        d="M18 21H7V8l7-7l1.25 1.25q.175.175.288.475q.112.3.112.575v.35L14.55 8H21q.8 0 1.4.6q.6.6.6 1.4v2q0 .175-.05.375t-.1.375l-3 7.05q-.225.5-.75.85T18 21Zm-9-2h9l3-7v-2h-9l1.35-5.5L9 8.85ZM9 8.85V19ZM7 8v2H4v9h3v2H2V8Z"
      />
    </svg>
  );
}
